export const BlocksNotFound = ({ isClause }: { isClause: boolean }) => {
  return (
    <div className="text-info-400 w-full py-16 text-center select-none">
      {`None of the ${isClause ? 'clauses' : 'blocks'} match your search criteria`}
    </div>
  );
};
